<script>
import Address from "@nextories/vue-core-components/src/components/molecules/address/NxtCoreAddress.vue";
import AutoCompleteAddress from "../../molecules/address/AutoCompleteAddress.vue";

export default {
  extends: Address,
  name: "Address",
  components: {
    AutoCompleteAddress,
  },
};
</script>
